import React from 'react';
import { Label } from '@creditflowresearch/uilib/Badge/Label';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import ISector from '@/creditflowresearch/domain/vo/IDealSector';

import styles from './styles.module.scss';

const TableSectorTooltip = ({
  sector,
  tooltip,
}: { sector: ISector, tooltip: string }) => (
  <Tooltip
    placement="bottom"
    content={ tooltip }
  >
    <Label
      className={ styles.sectorLabel }
      backgroundColor={ sector.color }
    >
      { sector.abbreviation }
    </Label>
  </Tooltip>
);

export default TableSectorTooltip;
